// token过期及刷新
export const REFRESH_TIME = 1290000
export const EXPIRES_TIME = 1296000
// export const REFRESH_TIME = 60
// export const EXPIRES_TIME = 70



// WEBPACK FOOTER //
// ./src/assets/js/config.js